import React from "react";

import LayoutSwitcher from "./LayoutSwitcher";

export default ({ children }) =>
  <LayoutSwitcher mobile={null} desktop={children} />;



// WEBPACK FOOTER //
// ./src/components/layout/Desktop.js